<!--<ara-side-nav class="inside-topnav" [routesFlag]="routesFlag" [reportRoutes]="reportRoutes"></ara-side-nav>-->

<div class="page-content-wrapper">
	<div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
		<ol class="breadcrumb bc-3"  >
			<li>
			<a [routerLink]="'/home'">Home</a>
			</li>
			<li>
			<a>Performance Dashboard</a>
			</li>
		  </ol>
			<div class="inner-wrapper">
			<div class="sub-wrapper" [ngStyle]="((moduleValue != 'QHSSE KPI' && moduleValue != 'Leaderboard Dashboard' && moduleValue!='') && switchbtn == false) ? {'width': dataCount +'px'} : {'width':'auto'}">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item active" aria-current="page">
							Performance Dashboard
						</li>
						<li class="filter-sort">
							<div class="filter-sort-wrapper" (clickOutside)="onClickedOutside()">
								<a class="settings" data-toggle="collapse" data-target="#filter" (click)="onTabOpen()">
									<i class="fa fa-filter" aria-hidden="true" pTooltip="Filter"
										tooltipPosition="top"></i>
								</a>
								<div class="outer-wrapper" *ngIf="hideFilter">
									<ul class="filter-section-wrapper collapse" id="filter">
										<li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Unit</h5>
												<p-multiSelect [options]="unitList"  [(ngModel)]="selectedUnit"
												(onChange)="UnitOnChange()"
												></p-multiSelect>
											</div>
										</li>
										<li *ngIf="moduleValue=='Observation Category' || moduleValue=='Incident Category'">
											<div class="leave-type">
												<h5 class="margin-bottom-10">Category</h5>
												<p-multiSelect [options]="CategoryList"  [(ngModel)]="selectedCategory"></p-multiSelect>
											</div>
										</li>
										<li *ngIf="moduleValue=='POB Roster' || moduleValue=='POB Roster MonthWise'">
											<div class="leave-type">
												<h5 class="margin-bottom-10">Location</h5>
												<p-multiSelect [options]="LocationList"  [(ngModel)]="selectedLocation"></p-multiSelect>
											</div>
										</li>
										<li *ngIf="moduleValue=='POB Roster' || moduleValue=='POB Roster MonthWise'">
											<div class="leave-type">
												<h5 class="margin-bottom-10">Pass Type</h5>
												<p-multiSelect [options]="PassTypeList"  [(ngModel)]="selectedPassType"></p-multiSelect>
											</div>
										</li>
										<div class="clearfix"></div>
										 
										<li>
											<div class="leave-type">
												<h5> <div class="col-lg-6 col-md-6 col-sm-6 no-padding-left">Month Range</div>
													<div *ngIf="moduleValue=='Observation Category' || moduleValue=='Incident Category'" class="col-lg-6 col-md-6 col-sm-6 no-padding-left"><input [(ngModel)]="RemoveEmpty"  type="checkbox"/>Remove Empty</div></h5>
												<div class="
                            col-lg-12 col-md-11 col-sm-11
                            no-padding
                            margin-top-10
                          ">
													<div class="col-lg-6 col-md-6 col-sm-6 no-padding-left">
														<p-calendar [(ngModel)]="dateFrom" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2000:2030"
                            placeholder="From" (click)="setToYear()"></p-calendar>
													</div>
													<div class="col-lg-6 col-md-6 col-sm-6 no-padding-right">
														<p-calendar [(ngModel)]="dateTo" view="month" dateFormat="mm/yy" [yearNavigator]="false"
                            placeholder="To" [minDate]="minDateValue" [maxDate]="maxDateValue" [readonlyInput]="true"></p-calendar>
													</div>
                          <div *ngIf="!dateFrom || !dateTo || showMonthError">
                            <span class="error-msg-colour">Please select month range</span>
                          </div>
													<div class="clearfix"></div>
												</div>
												<div class="clearfix"></div>
											</div>
										</li>
										<div class="clearfix"></div>
										<div class="clearfix"></div>
										<li class="filter-footer">
											<footer>
												<a (click)="resetFilter()" role="button" class="btn btn-primary primary-btn button-reset">
													<i class="fa fa-refresh"></i>Reset

												</a>
												<a (click)="doneFilter()" role="button" class="btn btn-primary primary-btn button-submit">
													<i class="fa fa-check"></i>Done
												</a>
											</footer>
										</li>
									</ul>
								</div>
							</div>
							<div class="clearfix"></div>
						</li>
					</ol>
				</nav>
				<div class="section-wrapper">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
						<div class="
                col-lg-7 col-md-6 col-sm-6 col-xs-6
                no-padding
                margin-top-10
              "></div>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="section-wrapper">
					<div class="sub-section-wrapper">
						<div id="collapseOne" class="panel-collapse collapse in" role="tabpanel"
							aria-labelledby="headingOne">
							<div class="search-details-wrapper">
								<div class="col-lg-2 col-md-3 col-sm-3 col-xs-3 auto-width">
									<div class="form-group">
										<div><label for="title">Modules</label></div>
										<p-dropdown [options]="moduleList" [(ngModel)]="moduleValue"
											placeholder="Select" [style]="{ width: '250px' }"
											(onChange)="selectModule($event.value)"></p-dropdown>
									</div>
								</div>
								<div *ngIf="moduleValue != 'QHSSE KPI'  && moduleValue != '' && moduleValue != 'Observation By Observer' && moduleValue != 'Training Compliance' && moduleValue != 'Energy Waste Consumption' && moduleValue != 'Energy Waste Consumption UnitWise' && moduleValue != 'Incident Register' && moduleValue != 'POB Roster' && moduleValue != 'POB Roster MonthWise'"
									class="col-lg-2 col-md-3 col-sm-3 col-xs-3 auto-width">
									<div class="form-group">
										<label>Chart</label>
										<p-inputSwitch [(ngModel)]="switchbtn"></p-inputSwitch>
										&nbsp;&nbsp;&nbsp;<label>Data</label>
									</div>
								</div>
								<div class="clearfix"></div>
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
        <div class="section-wrapper">
          <div class="sub-section-wrapper">
            <ara-chart *ngIf="!switchbtn" [moduleValue] = 'moduleValue' [data] = 'data'></ara-chart>
            <ara-performance-data *ngIf="switchbtn" [moduleValue] = 'moduleValue' [data] = 'data' [selectedUnit] = 'selectedUnit' [year]='year' [MonthRange] = 'MonthRange' [isRefresh] = 'isRefresh'></ara-performance-data>
          </div>
        </div>
			</div>
		</div>
	</div>
	<div class="clearfix"></div>
</div>
